import React, { useState } from 'react';

function GuessInput({ onSubmit }) {
  const [guess, setGuess] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const numericGuess = parseInt(guess);
    if (isNaN(numericGuess)) return alert('Please enter a valid year.');
    onSubmit(numericGuess);
    setGuess('');
  };

  const handleKeyPress = (e) => {
    // Allow only digits, backspace, delete, arrow keys
    const isDigit = /^\d$/.test(e.key);
    const isAllowedKey = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key);
    
    if (!isDigit && !isAllowedKey) {
      e.preventDefault();
    }

    // Prevent more than 4 digits
    if (isDigit && guess.length >= 4 && !window.getSelection().toString()) {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    // Only allow digits and limit to 4 characters
    const sanitizedValue = value.replace(/\D/g, '').slice(0, 4);
    setGuess(sanitizedValue);
  };

  const inputStyle = {
    fontSize: '2rem',
    padding: '0.8rem 1.2rem',
    border: '2px solid #000',
    background: 'none',
    width: '160px',
    letterSpacing: '0.2em',
    fontFamily: 'Helvetica Neue, Arial, sans-serif',
    textAlign: 'center',
    outline: 'none',
    transition: 'all 0.2s ease',
    WebkitAppearance: 'none',
    MozAppearance: 'textfield',
    '&::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0
    },
    '&::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0
    }
  };

  const formStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  };

  return (
    <div>
      <form onSubmit={handleSubmit} style={formStyle}>
        <input
          type="text"
          name="guess_date"
          inputMode="numeric"
          pattern="\d*"
          maxLength="4"
          value={guess}
          onChange={handleChange}
          onKeyDown={handleKeyPress}
          placeholder='When was this?'
          className="guess-input"
          autoComplete="off"
        />
        <button type="submit" className="guess-submit-button">
          ⏎
        </button>
      </form>
    </div>
  );
}

export default GuessInput;